import { ETxnSpeed } from "../transaction-speeds/ETxnSpeed";

export const CUSTOMER_ACCOUNT_ALLOWED_SPEEDS = new Set<string>([
  ETxnSpeed.FOUR_DAY,
  ETxnSpeed.TWO_DAY,
  ETxnSpeed.ONE_DAY_NO_RESERVE,
  ETxnSpeed.ZERO_DAY_NO_RESERVE,
]);

export const isValidCustomerAccountSpeed = (speed: ETxnSpeed) =>
  CUSTOMER_ACCOUNT_ALLOWED_SPEEDS.has(speed);
